import React from 'react';

type FeatureItem = {
  title: string;
  description: string;
  link?: string;
};

type FeatureListProps =
  | { items?: FeatureItem[]; features?: FeatureItem[] }
  | { items: FeatureItem[] };

export const FeatureList: React.FC<FeatureListProps> = ({ items, features }) => {
  // Support both `items` (legacy) and `features` (new) props
  const list: FeatureItem[] = (features ?? items ?? []) as FeatureItem[];

  if (!Array.isArray(list) || list.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      {list.map((item, index) => (
        <div
          key={index}
          className="bg-zinc-50 dark:bg-zinc-800 p-6 rounded-lg border border-zinc-200 dark:border-zinc-700"
        >
          <h4 className="text-xl font-medium mb-2 dark:text-white">
            {item.title}
          </h4>
          <p className="text-zinc-600 dark:text-zinc-300">{item.description}</p>
          {item.link && (
            <a
              href={item.link}
              className="inline-block mt-3 text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
            >
              Learn more →
            </a>
          )}
        </div>
      ))}
    </div>
  );
};
